import { Fragment } from "react"
import { FiltersProvider } from "../../components/providers/FiltersProvider";
import OperationTypeList from "./operation-list/OperationTypeList";

const OperationTypeListWrapper = () => {


    return (
        <Fragment>
            <FiltersProvider>
                <OperationTypeList/>
            </FiltersProvider>
        </Fragment>
    )
}

export default OperationTypeListWrapper